import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allcurrentClassLoading : true,
    allCurrentClassSuccess : null,
    allCurrentClassError : '',
    currentClassLoading : false,
    currentClass : null,
    currentClassErrro : ''    
}


export const currentClassTypeSlice = createSlice({
    name: 'current-class',
    initialState,
    reducers: {
        setAllCurrentClassLoading: (state, action) => {
            state.allcurrentClassLoading = true;
            state.allCurrentClassSuccess = null;
            state.allCurrentClassError = '';
        },
        setAllCurrentClassSuccess: (state, action) => {
            state.allcurrentClassLoading = false;
            state.allCurrentClassSuccess = action.payload;
            state.allCurrentClassError = '';
        },
        setAllCurrentClassError: (state, action) => {
            state.allcurrentClassLoading = false;
            state.allCurrentClassSuccess = null;
            state.allCurrentClassError = action.payload;
        },
        getcurrentClassLoading: (state, action) => {
            state.currentClassLoading = true;
            state.currentClass = action.payload;
            state.currentClassErrro = '';
        },
        getcurrentClassById: (state, action) => {
            state.currentClassLoading = false;
            state.currentClass = action.payload;
            state.currentClassErrro = '';
        },
        getcurrentClassError: (state, action) => {
            state.currentClassLoading = false;
            state.currentClass = null;
            state.currentClassErrro = action.payload;

        },
        resetCurrentClass: (state, action) => {
            state.currentClass = null
        },
    },
})

// Action creators are generated for each case reducer function
export const { setAllCurrentClassLoading, setAllCurrentClassSuccess, setAllCurrentClassError,getcurrentClassLoading, getcurrentClassById,getcurrentClassError,resetCurrentClass} = currentClassTypeSlice.actions

export default currentClassTypeSlice.reducer;